import { gql } from '@apollo/client'
import { pick } from 'ramda'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import React from 'react'

import { analyticsClient } from '../../../../../../utils/apollo/api'
import { useGenericState } from '../../../../../../packages/kiti/components/helpers/GenericState'
import { usePaginatedQuery } from '../../../../../../utils/apollo/_helpers/pagination'
import { useWidgetState } from '../../../WidgetWrapper'
import Button from '../../../../../../packages/kiti/components/actions/Button'
import Center from '../../../../../../packages/kiti/components/helpers/Center'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useGroupedNonCompliancesState = () => React.useContext(Context)
export const useGroupedNonCompliances = () => useGroupedNonCompliancesState()?.groupedNonCompliances

const QUERY = gql`
  query GroupedNonCompliances($filter: GroupedNonCompliancesFilter, $page: Int) {
    groupedNonCompliances(filter: $filter, page: $page) {
      id
      name
      description
      totalCount
      nonCompliancesCount
    }
  }
`

const GroupedNonCompliancesLoader = ({ children }) => {
  const filter = useCleanFilterForRequest() || {}
  const { value } = useGenericState()
  const { value: widgetState } = useWidgetState()

  const { data, fetchMore, done, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      filter: {
        nonComplianceType: value?.nonComplianceType?.id || 'service_order',
        entity: widgetState?.entity?.id || 'checklist',
        ...pick(['placeIds', 'placeLevelIds', 'userIds', 'checklistIds', 'date'], filter)
      }
    },
    client: analyticsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
      <Separator weight={2} />
      {!done && !state.loading && !state.isFetchingMore && (
        <Center>
          <Button color="dark3" transparent onClick={fetchMore}>
            Carregar mais
          </Button>
        </Center>
      )}
      <Separator usePadding weight={4} />
    </StatePresenter>
  )
}

export default GroupedNonCompliancesLoader
